import { Component, ElementRef, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { ModalService } from 'src/app/service/modal.service';
import { playCompareAnimation } from './animation';
import gsap from 'gsap';
import { ChromecastTypes, getChromecastTypes } from './data';
import { LocalizationService } from 'src/app/service/localization.service';
import { getCompareModalCopy, getSpecsFooterCopy } from 'src/app/utils/localization';
import { toggleTimeline } from 'src/app/utils/toggleTimeline';
import { AnalyticsEvent, triggerEvent } from 'src/app/utils/analytics';
import { JsonKey } from 'src/app/data/type/locale-copy-key';

@Component({
  selector: 'app-c05-compare-modal',
  templateUrl: './c05-compare-modal.component.html',
  styleUrls: ['./c05-compare-modal.component.scss', 'c05-compare-modal-portrait.component.scss'],
})
export class C05CompareModalComponent implements AfterViewInit {
  @ViewChild('compareModal') compareModal: ElementRef;
  @ViewChild('tableFocus') tableRef: ElementRef;
  @ViewChild('scrollContent') scrollContent: ElementRef;
  @ViewChild('footerButtonRef') footerButtonRef: ElementRef;
  @ViewChild('closeButtonRef') closeButtonRef: ElementRef;

  public chromeCastTypes: ChromecastTypes;
  public footerCopy: Array<string>;
  public ariaLabelCopy = {
    [JsonKey.CLOSE_BUTTON_ARIA_LABEL]: '',
    [JsonKey.COMPARE_MODAL_ARIA_LABEL]: '',
  };

  public jsonKey = JsonKey;
  public modalElement: HTMLElement | null;
  public activateFocusTrap: boolean = false;
  private modalTimeline: GSAPTimeline = gsap.timeline({ paused: true });
  private scrollContentElement: HTMLElement | null;
  private footerButtonRefElement: HTMLElement | null;
  // private currentScrollTop: number = 0;
  // private currentScrollTarget: HTMLElement | null;

  constructor(public modalService: ModalService, private localizationService: LocalizationService) {
    this.chromeCastTypes = getChromecastTypes(this.localizationService);
    this.footerCopy = getSpecsFooterCopy(this.localizationService);
    this.ariaLabelCopy = getCompareModalCopy(this.localizationService);
  }

  ngAfterViewInit(): void {
    this.modalElement = this.compareModal.nativeElement;
    this.scrollContentElement = this.scrollContent.nativeElement;
    this.footerButtonRefElement = this.footerButtonRef.nativeElement;

    this.setupTimeline();
    playCompareAnimation();
    this.modalService.isComparisonModalOpen.subscribe((isVisible) => {
      toggleTimeline(isVisible, this.modalTimeline, () => this.toggleFocusTrap());
    });
  }

  toggleFocusTrap() {
    this.activateFocusTrap = !this.activateFocusTrap;
    if (this.activateFocusTrap) {
      this.closeButtonRef.nativeElement.focus();
    }
  }

  setupTimeline() {
    this.modalTimeline
      .fromTo(this.modalElement, { y: '100%' }, { y: '0', duration: 0.3, ease: 'power4.out' })
      .fromTo(
        '[data-animation="c05-compare-modal-content"]',
        { autoAlpha: 0, y: 50, ease: 'sine.out' },
        { autoAlpha: 1, y: 0, stagger: 0.1, duration: 0.2, ease: 'sine.out' },
        0,
      );
  }

  onCloseButtonClick() {
    if (gsap.isTweening(this.modalTimeline)) gsap.killTweensOf(this.modalTimeline);
    this.modalService.setIsComparisonModalVisible(false);
  }

  handleTitleClick(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const hasSubTarget = !!target.querySelector('sup');

    if (hasSubTarget) {
      // this.currentScrollTop = this.scrollContentElement.scrollTop;
      this.scrollContentElement.scrollTo({
        top: this.scrollContentElement.scrollHeight,
        behavior: 'smooth',
      });
      // this.currentScrollTarget = target;
      this.footerButtonRefElement.focus();
    }
  }

  // Footer used to take you to the top.
  // Keeping here in case we have to add it back.
  // handleFooterClick() {
  //   this.scrollContentElement.scrollTo({
  //     top: this.currentScrollTop,
  //     behavior: 'smooth',
  //   });
  //   if (this.currentScrollTarget) this.currentScrollTarget.focus();
  // }

  @HostListener('document:keydown', ['$event'])
  keyPress(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.modalService.getIsComparisonModalVisible()) {
      this.onCloseButtonClick();
    }
  }

  handleScroll(event: Event) {
    const element = event.target as HTMLElement;
    const scrollHeight = element.scrollHeight - element.scrollTop;
    if (Math.ceil(scrollHeight) <= element.clientHeight) {
      triggerEvent(AnalyticsEvent.compareBottom);
    }
  }
}
